export const metaData = {
    urlMetaData: [
        {
            url: '/novosti/news',
            title: 'Новости НДВ Супермаркет Недвижимости',
            description: 'Новости компании НДВ Супермаркет Недвижимости о ходе строительства новостроек и развитии окружающей инфраструктуры, различных мероприятиях, акциях и скидках, а также аналитические статьи и обзоры',
            h1String: 'Новости',
            keywords: 'новости компании НДВ, новости рынка недвижимости, новости застройщиков',
            showEmailSubscription: false,
        }
    ]
}
